import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { authGuard } from 'lib/auth/auth-guard.js';
import { GlobalErrorComponent } from 'lib/error/global-error.component.js';
import { Global404Component } from 'src/app/modules/shared/global-404.component.js';
import { EmptyComponent } from './pages/home/empty.component.js';
import { HomeComponent } from './pages/home/home.component.js';
import { LoginComponent } from './pages/auth/login.component.js';
import { TypeComponent } from './pages/type-routes/type.component.js';
import { SignupComponent } from './pages/auth/signup.component.js';
import { InsufficientPermissionsComponent } from './pages/permissions/insufficient-permissions.component.js';
import { LogoutComponent } from './pages/auth/logout.component.js';
import { ForgottenPasswordComponent } from './pages/auth/forgotten-password.component.js';
import { ResetPasswordComponent } from './pages/auth/reset-password.component.js';
import { UnsubscribeComponent } from './pages/auth/unsubscribe.component.js';
import { PdfPageComponent } from './pages/pdf/pdf-page.component.js';
import { PrivacyPolicyComponent } from './pages/about/privacy-policy.component.js';
import { CookiePolicyComponent } from './pages/about/cookie-policy.component.js';
import { TermsAndConditionsComponent } from './pages/about/terms-and-conditions.component.js';
import { routingModulePaths } from './app-routing-module-helper.js';
import { ConfirmEmailComponent } from './pages/auth/confirm-email.component.js';
import { RefundPolicyComponent } from './pages/about/refund-policy.component.js';

const routes: Routes = [
	{
		path: '',
		component: HomeComponent,
		pathMatch: 'full'
	},
	{
		// path: 'auth/:mainType/:type/:action/:primaryId/:secondaryId/:tertiaryId',
		matcher: (segments, group, route) => {
			const firstSegment: string | undefined = segments[0]?.path;

			if (firstSegment.toLowerCase() === 'auth') {
				return {
					consumed: segments
				};
			}

			return null;
		},
		canActivate: [authGuard],
		canActivateChild: [authGuard],
		component: TypeComponent,
		pathMatch: 'full'
	},
	{
		// path: 'pdf/:type/:itemId/:userId/:containerItemId',
		matcher: (segments, group, route) => {
			const firstSegment: string | undefined = segments[0]?.path;

			if (firstSegment.toLowerCase() === 'pdf') {
				return {
					consumed: segments
				};
			}

			return null;
		},
		component: PdfPageComponent,
		pathMatch: 'full'
	},
	{
		path: routingModulePaths.insufficientPermissions,
		component: InsufficientPermissionsComponent,
		pathMatch: 'full'
	},
	{
		path: routingModulePaths.privacy,
		component: PrivacyPolicyComponent,
		pathMatch: 'full'
	},
	{
		path: routingModulePaths.cookies,
		component: CookiePolicyComponent,
		pathMatch: 'full'
	},
	{
		path: routingModulePaths.refundPolicy,
		component: RefundPolicyComponent,
		pathMatch: 'full'
	},
	{
		path: routingModulePaths.terms,
		component: TermsAndConditionsComponent,
		pathMatch: 'full'
	},
	{
		path: routingModulePaths.login,
		component: LoginComponent,
		pathMatch: 'full'
	},
	{
		path: routingModulePaths.unsubscribe,
		component: UnsubscribeComponent,
		pathMatch: 'full'
	},
	{
		path: routingModulePaths.forgottenPassword,
		component: ForgottenPasswordComponent,
		pathMatch: 'full'
	},
	{
		path: routingModulePaths.confirmEmail,
		component: ConfirmEmailComponent,
		pathMatch: 'full'
	},
	{
		path: routingModulePaths.resetPassword,
		component: ResetPasswordComponent,
		pathMatch: 'full'
	},
	{
		path: routingModulePaths.signup,
		component: SignupComponent,
		pathMatch: 'full'
	},
	{
		path: routingModulePaths.logout,
		component: LogoutComponent,
		pathMatch: 'full'
	},
	{
		path: routingModulePaths.empty,
		component: EmptyComponent,
		pathMatch: 'full'
	},
	{
		path: routingModulePaths.error,
		component: GlobalErrorComponent
	},
	{
		path: '**',
		component: Global404Component
	}
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {
			preloadingStrategy: PreloadAllModules,
			useHash: false,
			initialNavigation: 'enabledBlocking', // needed for SSR
			anchorScrolling: 'enabled', // needed for scrolling to anchors on home page
			scrollPositionRestoration: 'enabled'
		})
	],
	exports: [RouterModule]
})
export class AppRoutingModule {}
